import type { Activity } from "@/entities/activity";

import { format } from "@/utilities/date";

export const getActivityContextDate = (activity?: Activity) => {
  return activity ? format(activity.created_at, "LLLL") : undefined;
};
